module.exports = __webpack_public_path__ + "img/187.d8b1b68c.jpg";